import { Link } from "react-router-dom";
import '../style/home/H_Footer.css';

let links=[
  {
    id:1,
    link_name:"صفحه اصلی",
    path:"/"
  },
  {
    id:2,
    link_name:"امکانات",
    path:"/"
  },
  {
    id:3,
    link_name:"فروشگاه",
    path:"/"
  },
  {
    id:4,
    link_name:"قوانین و شرایط استفاده",
    path:"/"
  }
]

const H_Footer=()=>{
  return(
    <div className="h-footer">
      <div className="h-footer-links">
        {links.map(item=>(
          <Link key={item.id} to={item.path} className="h-footer-links-item">
            {item.link_name}
          </Link>
        ))}
      </div>
      <div className="h-footer-copyright">
        تمامی حقوق مادی و معنوی متعلق به پلتفرم آزمون می باشد
      </div>
    </div>
  )
}

export default H_Footer;